// Import libraries
/*

class to generate eoc export record

  identifier: Joi.any().optional(),
  state: Joi.string().valid( ...Object.keys(STATES) ).required(),
  eocId: Joi.string().required(),
  exportRecordId: Joi.string().required(), // timestamp in millisecond when it was created
  patientPeriodStart: Joi.string().optional(), // Note this is optional
  patientPeriodEnd: Joi.string().required(), // This is required. Need to know the last date/second someone exported info
  careTeamPeriodStart
  careTeamPeriodEnd
  condition start and end
  message log start and end
  body sites start and end
  image sets start and end
  video transcript start and end

*/

const Joi = require('joi');

// Import variables
const { STATES, USER_TYPES } = require('@bcm/constants');
const { joiValidateObj, identifiers } = require('../datastructComponents');
const { DataTableBase } = require('./base.class');

// Create schema
const schema = {
  identifier: Joi.any().optional(),
  state: Joi.string().valid( ...Object.keys(STATES) ).required(),
  eocId: Joi.string().required(),
  exportRecordId: Joi.string().required(),
  patientPeriodStart: Joi.string().required(),
  patientPeriodEnd: Joi.string().optional(),
  careTeamPeriodStart: Joi.string().required(),
  careTeamPeriodEnd: Joi.string().optional(),
  conditionPeriodStart: Joi.string().required(),
  conditionPeriodEnd: Joi.string().optional(),
  messageLogPeriodStart: Joi.string().required(),
  messageLogPeriodEnd: Joi.string().optional(),
  bodySitesPeriodStart: Joi.string().required(),
  bodySitesPeriodEnd: Joi.string().optional(),
  imageSetsPeriodStart: Joi.string().required(),
  imageSetsPeriodEnd: Joi.string().optional(),
  videoTranscriptPeriodStart: Joi.string().required(),
  videoTranscriptPeriodEnd: Joi.string().optional(),
  userId: Joi.string().required(),
  userType: Joi.string().valid( ...Object.keys( USER_TYPES) ).required(),
};

// Define class
class EocExportRecord extends DataTableBase {
  constructor ( obj ) {
    joiValidateObj(schema, obj);
    super(
      identifiers.eocExportRecord.buildPk(obj.eocId),
      identifiers.eocExportRecord.buildSk(obj.state, obj.eocId, obj.exportRecordId)
    );
    for (const key of Object.keys(obj)) {
      if(obj[key] !== undefined) {
        if(obj[key]) {
          this[key] = obj[key];
        }
      }
    }
  }
}

exports.EocExportRecord = EocExportRecord;
exports.eocExportRecordSchema = schema;